import { Password } from "primereact/password";
import type { FC } from "react";
import {
  Controller,
  type Control,
  type FieldPath,
  type RegisterOptions,
} from "react-hook-form";
import authStyles from "@/components/AuthCard.module.css";
import type { NewPasswordFormValues } from "@/pages/auth/NewPasswordPage/NewPasswordForm";
import styles from "@/pages/auth/NewPasswordPage/PasswordInputField.module.css";

const getInputClassName = (isSuccess: boolean, hasError: boolean): string => {
  if (isSuccess) {
    return `${authStyles.input} ${styles.inputSuccess}`;
  }
  if (hasError) {
    return `${authStyles.input} ${styles.inputError}`;
  }
  return authStyles.input;
};

interface PasswordInputFieldProps {
  control: Control<NewPasswordFormValues>;
  hasError: boolean;
  isSuccess: boolean;
  name: FieldPath<NewPasswordFormValues>;
  rules: RegisterOptions<NewPasswordFormValues>;
}

const PasswordInputField: FC<PasswordInputFieldProps> = ({
  control,
  hasError,
  isSuccess,
  name,
  rules,
}) => (
  <div className={styles.inputIconWrap}>
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Password
          feedback={false}
          inputId={name}
          inputRef={field.ref}
          pt={{ input: { className: getInputClassName(isSuccess, hasError) } }}
          toggleMask
          value={field.value ?? ""}
          onBlur={field.onBlur}
          onChange={field.onChange}
        />
      )}
      rules={rules}
    />
    {isSuccess && !hasError && (
      <i
        aria-hidden="true"
        className={`pi pi-check ${styles.statusIcon} ${styles.statusIconSuccess}`}
      />
    )}
    {hasError && (
      <i
        aria-hidden="true"
        className={`pi pi-times ${styles.statusIcon} ${styles.statusIconError}`}
      />
    )}
  </div>
);

export default PasswordInputField;
